import { useEffect } from "react";
import { initPixel } from "@/lib/meta-pixel";

export function useMetaPixel(): void {
  useEffect(() => {
    const pixelId = import.meta.env.VITE_META_PIXEL_ID as string | undefined;
    initPixel(pixelId);
  }, []);
}
